import angular from 'angular'
import { goodsStatistics, management } from 'redevConfig'
const list = (goodsStatistics && goodsStatistics.list) || ''
const relatedInvoice = (goodsStatistics && goodsStatistics.relatedInvoice) || ''
const relatedInvoiceDetail = (management && management.detail) || ''

const goodsStatisticsList = list ? require(`redevelopment/statistics/goodsStatistics/${list.templateName}`) : require('./view/goodsStatisticsList.html')
const goodsStatisticsListCtrl = list ? require(`redevelopment/statistics/goodsStatistics/${list.controllerName}`) : require('./goodsStatisticsListCtrl')
const relatedInvoiceTempalte = relatedInvoice ? require(`redevelopment/statistics/goodsStatistics/${relatedInvoice.templateName}`) : require('./view/relatedInvoice.html')
const relatedInvoiceCtrl = relatedInvoice ? require(`redevelopment/statistics/goodsStatistics/${relatedInvoice.controllerName}`) : require('./relatedInvoiceCtrl')
const relatedInvoiceDetailTemplate = relatedInvoiceDetail ? require(`redevelopment/input/management/${relatedInvoiceDetail.templateName}`) : require('../../../input/inputInvoice/management/view/managementDetail.html')

export default angular
    .module('app.goodsStatistics', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state('statistics.inputStatistics.goodsStatistics', {
                abstract: true,
                url: '/goodsStatistics',
                template: '<div ui-view></div>',
                title: '商品统计',
                default: 'statistics.inputStatistics.goodsStatistics.list',
            })
            .state('statistics.inputStatistics.goodsStatistics.list', {
                url: '/list',
                template: goodsStatisticsList,
                controller: 'goodsStatisticsListCtrl',
            })
            .state('statistics.inputStatistics.goodsStatistics.relatedInvoice', {
                url: '/relatedInvoice',
                title: '关联发票',
                template: relatedInvoiceTempalte,
                controller: 'relatedInvoiceCtrl',
            })
            .state('statistics.inputStatistics.goodsStatistics.relatedInvoiceDetail', {
                url: '/relatedInvoiceDetail/:object',
                template: relatedInvoiceDetailTemplate,
                controller: 'managementDetailCtrl',
                title: '关联发票详情',
            })
    }])
    .controller('goodsStatisticsListCtrl', goodsStatisticsListCtrl.default)
    .controller('relatedInvoiceCtrl', relatedInvoiceCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/statistics/inputStatistics/goodsStatistics/index.js